import { Outlet, useOutletContext } from 'react-router-dom'

import { CostCentersList } from 'modules/cost_centers/components/CostCenterList'

const CostCentersListPage = () => {
  const { canManageCostCenters, hasFeatureCostCenterManagement } = useOutletContext<{
    canManageCostCenters: boolean
    hasFeatureCostCenterManagement: boolean
  }>()

  return (
    <>
      <CostCentersList canManageCostCenters={canManageCostCenters} />
      <Outlet
        context={{
          canManageCostCenters,
          hasFeatureCostCenterManagement,
        }}
      />
    </>
  )
}

export default CostCentersListPage
